<template>
  <div>
    <h1>Processing Payment...</h1>
    <form
      id="paymentForm"
      class="form-horizontal"
      role="form"
      action="https://regstd.mfu.ac.th/debt/ipaymentp"
      method="post"
    >
      <input type="hidden" name="channel" value="student" />
      <input type="hidden" name="std" :value="stdValue" />
      <input type="hidden" name="urlback" :value="urlBack" />
      <input type="hidden" name="lang" :value="lang" />
      <input type="hidden" name="lockselect" value="1" />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Payment",
  data() {
    return {
      stdValue: "", // Example student ID
      urlBack: process.env.VUE_APP_API_ENDPOINT.includes("apigatewaytest")
        ? "https://er-test.mfu.ac.th/#/"
        : "https://reg-er.mfu.ac.th/#/", // Redirect URL after payment
      lang: "en" // Default language
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentUserId: function() {
      // eslint-disable-next-line no-undef
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    }
  },
  mounted() {
    this.stdValue = this.currentUserId;
    this.lang = this.appInfo.currentLocale.toUpperCase();
    console.log("Payment component mounted, auto-submitting form.");
    // Auto-submit the form
    setTimeout(() => {
      document.getElementById("paymentForm").submit();
    }, 1000);
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}
</style>
